import React, { Fragment, useState } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import PropTypes from "prop-types";

import ReactApexChart from "react-apexcharts";
import { Button } from "reactstrap";

const LineGraph = ({ comparisonData }) => {
  //グラフデータ
  const [dataSeries, setDataSeries] = useState(comparisonData["寄付・会費率"]);

  const items = [];
  for (const [key, value] of Object.entries(comparisonData)) {
    if (!(key === "categories")) {
      if (dataSeries === value) {
        items.push(
          <p
            style={({ color: "black" }, { fontWeight: "bold" })}
            onClick={(e) => {
              setDataSeries(value);
            }}
          >
            {key}
          </p>
        );
      } else {
        items.push(
          <p
            style={{ color: "gray", display: "inline-block" }}
            onClick={(e) => {
              setDataSeries(value);
            }}
          >
            {key}
          </p>
        );
      }
    }
  }

  //グラフオプション
  const dataOptions = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },

    stroke: {
      curve: "straight",
      width: 2,
    },

    grid: {
      row: {
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: comparisonData["categories"],
    },
  };

  return (
    <>
      <div className="changedata">{items}</div>
      <ReactApexChart
        options={dataOptions}
        series={dataSeries}
        type="line"
        height={350}
      />
    </>
  );
};

export default LineGraph;
